import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=1b881677&scoped=true"
import script from "./cmp.vue?vue&type=script&lang=js"
export * from "./cmp.vue?vue&type=script&lang=js"
import style0 from "./cmp.vue?vue&type=style&index=0&id=1b881677&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b881677",
  null
  
)

export default component.exports